import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/videocallcompleteprovision/private";

const VideoCallCompleteProvisionApi = new ApiService(ROOT_URL, "", {
  getProvisionsByProcessId: function(ctx, processId, onSuccess, onError) {
    this.apiGET(ctx, "?processId=" + processId, onSuccess, onError);
  }
});

export default VideoCallCompleteProvisionApi;



// WEBPACK FOOTER //
// ./src/service/VideoCallCompleteProvisionService.js